import { createContext, useContext } from "react"

import { ObjectsData } from "@organisms/ObjectsView/ObjectsView.types"

import { CardsViewContextValues } from "./CardsView.types"

// `any` is used here as workaround because it is not possible to create a context with a generic type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CardsViewContext = createContext<CardsViewContextValues<any> | undefined>(undefined)
CardsViewContext.displayName = "CardsView"

export default function useCardsView<T = ObjectsData>(): CardsViewContextValues<T> {
    const context = useContext(CardsViewContext)
    if (!context) {
        throw new Error("useCardsView must be used within a CardsView.Provider component")
    }

    return context as CardsViewContextValues<T>
}
